import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { LegacyFeatureType } from '@modules/ide-provisioner/plugins-rules/plugin-rules-bundle-dialog/legacy-feature-type';
import { useFeatureFlag, useServerConfigContext } from '@common/server-config-context/server-config-context';
import { AutoInstallPreset } from '../../../common/auto-install-preset';
import { ActionSelector } from '../../common/action-selector/action-selector';
export function BundledPluginContent(props) {
    const { className, rule, onRuleChange, legacyFeatureType } = props;
    const serverConfig = useServerConfigContext();
    const cloudModeEnabled = serverConfig.isCloud();
    const allowDenyPluginsListEnabled = useFeatureFlag('allowDenyPluginsListEnabled');
    const allowedActions = useMemo(() => {
        if (!allowDenyPluginsListEnabled) {
            if (legacyFeatureType === LegacyFeatureType.DisabledPlugins) {
                return {
                    'force-restrict': true,
                    disable: true
                };
            }
            if (legacyFeatureType === LegacyFeatureType.AutoInstallPlugins) {
                return {
                    'auto-install': true,
                    'force-auto-install': true
                };
            }
        }
        return {
            'force-restrict': true,
            restrict: true,
            disable: true,
            allow: true,
            'auto-install': !cloudModeEnabled,
            'force-auto-install': !cloudModeEnabled
        };
    }, [cloudModeEnabled, legacyFeatureType, allowDenyPluginsListEnabled]);
    const handleActionChange = useCallback((action) => onRuleChange({ ...rule, action }), [onRuleChange, rule]);
    return (_jsx(ActionSelector, { className: className, action: rule.action, onActionChange: handleActionChange, allowedActions: allowedActions, autoInstallPreset: AutoInstallPreset.Enable }));
}
